var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPreguntas02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,2.5C21.4,2.5,2.5,21.5,2.5,45c0,6.9,1.6,13.6,5,19.8L2.7,83c-0.2,0.5-0.2,1.2,0,1.8c0.5,1.9,2.5,3.2,4.4,2.7l18.2-4.8 c6,3.2,12.7,4.8,19.7,4.8c23.6,0,42.5-18.9,42.5-42.4S68.6,2.5,45,2.5z M45,68.3c-2.3,0-4.3-1.9-4.3-4.2c0-2.3,1.9-4.2,4.3-4.2 s4.3,1.9,4.3,4.2C49.3,66.4,47.3,68.3,45,68.3z M52.3,44.3L51,45.5c-2.1,2.3-2.7,3.4-2.7,5.7c0,1.8-1.4,3.2-3.2,3.2S42,52.9,42,51.2 c0-4.4,1.2-6.7,4.4-10.1l1.2-1.2c2.1-2.3,2.7-3.4,2.7-5.7c0-2.8-2.1-5-4.8-5.3c-2.8-0.2-5.5,1.9-5.8,4.8v1.1 c-0.2,1.6-1.6,2.8-3.2,2.8c-1.8,0-3.2-1.4-3.2-3.2c0-6.4,5.3-11.7,11.7-11.7S56.7,28,56.7,34.2C56.7,38.6,55.4,40.9,52.3,44.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPreguntas02);
export default __webpack_public_path__ + "static/media/ico-preguntas-02.b11936a82e6596c2417337deb674d200.svg";
export { ForwardRef as ReactComponent };